$(document).find('.js_slider').each((i,el) => {
    let sliderSpeed = $(el).attr('data-page_speed') ? $(el).attr('data-page_speed') : 4000
    let isAuto = $(el).attr('data-is_auto') == '0' ? false : {delay: sliderSpeed}
    new Swiper (el, {
        autoHeight: false,
        autoplay: isAuto,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletClass: 'slider__bullet',
            bulletActiveClass: 'slider__bullet_active',
            clickable: true,
        },
        loop: true,
        speed: 2000,
        modules: [window.SwiperModes.Autoplay,window.SwiperModes.Pagination ]
    })
})

